<template>
    <div>
        <!--　调查完成　-->
        <el-form :rules="rules" ref="form" :model="form" label-width="80px" class="event-form">
            <el-row>
                <el-col :span="24">
                    <el-form-item label="下一节点">
                        <span>制定解决方案</span>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="处理组" prop="currentDepartment">
                        <div class='el-form__inline'>
                            <el-select v-model="form.currentDepartment" filterable placeholder="请选择" @change="departmentChange">
                                <el-option v-for="item in departmentList" :key="item.id" :label="item.name"
                                           :value="item.id"></el-option>
                            </el-select>
                            <el-button :type="groupTasksTotal>=5?'danger':'success'" plain  >组繁忙度  ({{groupTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="处理人" prop="currentHandler">
                        <div class="el-form__inline">
                            <el-input v-model="form.currentHandler" disabled></el-input>
                            <el-button  type="primary" class="iconfont icon-gengduo icon" :disabled="dis_user" @click="toRequesterList"></el-button>
                            <el-button type="primary" :type="userTasksTotal>=5?'danger':'success'" plain >人员繁忙度  ({{userTasksTotal}})</el-button>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="解决标识" prop="solutionLabel">
                        <el-select v-model="form.solutionLabel" placeholder="请选择">
                            <el-option v-for="item in solutionLabel" :key="item.id" :label="item.cname"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="24">
                    <el-form-item label="解决方案">
                        <!-- <ueditor @getUeContent="getUeContent"></ueditor> -->
                        <ueditor v-model="solutionComment" :config="myConfig" :key="1" :value="2" @ready="editorReady"></ueditor>
                        <div>
                            <el-checkbox v-model="upKnowledge">解决方案保存到知识库</el-checkbox>
                        </div>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row v-if="upKnowledge">
                <el-col :span="12">
                    <el-form-item label="知识分类">
                        <el-select v-model="knowledgeClass" placeholder="请选择">
                            <el-option v-for="item in categoryList" :key="item.id" :label="item.title"
                                       :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="知识关键字">
                        <el-input v-model="knowledgeKeyword"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <!--<el-row>-->
                <!--<el-col :span="24">-->
                    <!--<el-form-item label="附件">-->
                        <!--<input style="font-size: 12px" type="file" @change="fileChange">-->
                        <!--<div v-for="(item ,i) in attachment" :key="i">{{ item.name }}</div>-->
                    <!--</el-form-item>-->
                <!--</el-col>-->
            <!--</el-row>-->
            <!--上传附件-->
            <el-row>
                <el-col :span="24">
                    <el-form-item label="附件">
                        <inputFile :data="attachment" :getFiles="getFiles"></inputFile>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-form-item>
                <el-button type="primary" @click="submit" :disabled="isSubmit">确定</el-button>
                <el-button type="default" @click="onCancel">取消</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    const VueUeditorWrap = window.VueUeditorWrap;
    import Config from "../../app.config";
    import ueditor from "../../components/ueditor.vue"
    import services from "./problem.service"
    import commonService from "../../services/common.service"
    import inputFile from "../common/inputFile.vue"
    import {getRules} from "./problem.rules";
    const rules=getRules()
    export default {
        props:{
            serialNumber:String,
            callback:Function
        },
        data() {
            return {
                rules:rules,
                form:{
                    currentDepartment:"",
                    currentHandler:'',
                    solutionLabel:"",
                },
                knowledgeClass:"",
                solutionComment:"",
                upKnowledge:false,
                departmentList:[],      // 处理组
                dis_user:true,
                attachment:[],
                knowledgeKeyword:"",
                categoryList:[],
                isSubmit:false,
                busynessUserbtn:true,
                groupTasksTotal:'',   //组任务数
                userTasksTotal:'',    //人员任务数量
                requesterInfo:{},
                myConfig: {
                    autoHeightEnabled: false,
                    initialFrameHeight: 200,
                    initialFrameWidth: '100%',
                    UEDITOR_HOME_URL: '/UEditor/',
                    // serverUrl: 'http://35.201.165.105:8000/controller.php'/cr/v1/review
                    // serverUrl:Config.baseURL+"upload",
                    // serverUrl:'http://wedof.beta.autoai.com/upload/'
                    serverUrl:Config.BASE_API + "upload/",
                },
            }
        },
        components:{ ueditor ,inputFile},
        computed:{
            dictionary(){
                return this.$store.state.dictionary;
            },
            solutionLabel(){
                return this.dictionary.solution_label;
            },
            // 知识分类id
            knowledgeType(){
                return this.$store.state.caseType.knowledge;
            }
        },
        created() {
            this.getDepartment();
            this.getCategoryList();
        },
        methods: {
            // 服务组
            getDepartment(){
                let params= {
                    departmentId:99999,
                    type:'group'
                }
                commonService.getDepartmentList(params).then(res => {
                    this.departmentList = res.list;
                })
            },
            departmentChange(){
                this.dis_user = this.form.currentDepartment ? false : true;
                this.requesterInfo = {
                    id:"",
                    name:"",
                };
                this.form.currentHandler = "";
                this.userTasksTotal= '';
                this.busynessUserbtn = this.requesterInfo.id ? false : true;
                let groupId=this.form.currentDepartment
                this.getGroupBusyness(groupId)
            },
            getGroupBusyness(id){
                services.busynessGroup(id).then(res => {
                    this.groupTasksTotal = res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // 获取知识分类
            getCategoryList(){
                commonService.categoryList(this.knowledgeType.id).then(res => {
                    this.categoryList = res;
                })
            },
            toRequesterList(){
                let id = this.form.currentDepartment.toString();
                this.$router.push({
                    path: '/appointUser',
                    name: "appointUser",
                    query: {
                        callback:this.getRequester,
                        id:id
                    }
                })
            },
            // 获取选择的组员
            getRequester(obj){
                this.requesterInfo = {
                    id:obj.internalUserid,
                    name:obj.name,
                };
                this.form.currentHandler = obj.name;
                this.busynessUserbtn = obj.internalUserid ? false : true;
                let userid=this.requesterInfo.id
                this.getUserBusyness(userid)
            },
            getUserBusyness(id){
                services.busynessUser(id).then(res => {
                    this.userTasksTotal= res.tasksTotal;
                }).catch(err => {
                    this.$message.error(err.message);
                })
            },
            // 编辑器获取内容
            // getUeContent(val){
            //     this.solutionComment = val;
            // },
            editorReady (editorInstance) {
                editorInstance.setContent('你可以在这里初始化编辑器的初始内容。');
                let _this = this
                editorInstance.addListener('contentChange', () => {
                  // console.log('编辑器内容发生了变化:', editorInstance.getContent());getContentTxt()
                  // _this.form.Body = editorInstance.getContent()
                   _this.solutionComment = editorInstance.getContent()
                });
            },
            submit(){
                this.isSubmit=true
                let params=this.getParams()
              if(!params.solutionComment){
                    this.isSubmit=false
                    this.$message.error('请填写解决方案')
                }else {
                    this.$refs['form'].validate(valid=>{
                        if (valid){
                            services.handle(params).then(res => {
                                this.$message.success("制定解决方案完成");
                                this.close(true);
                            }).catch(err => {
                                this.isSubmit=false
                                this.$message.error(err.message)
                            })
                        } else{
                            this.isSubmit=false
                            this.$message.error('错误')
                        }
                    })

                }

            },
            getParams(){
                let upKnowledge = this.upKnowledge ? "1" : "0";
                let params = {
                    ...this.form,
                    handle:"制定解决方案",
                    serialNumber:this.serialNumber,
                    currentHandler:this.requesterInfo.id,
                    solutionComment:this.solutionComment,
                    upKnowledge:upKnowledge,
                    attachment:this.attachment,
                };
                if(this.upKnowledge){
                    params.knowledgeKeyword = this.knowledgeKeyword.split(",");
                    params.knowledgeClass = this.knowledgeClass;
                }
                return params;
            },
            // fileChange(e){
            //     let files = e.target.files || e.dataTransfer.files;
            //     if (!files.length){
            //         return;
            //     };
            //     this.form.attachment = files[0];
            //     let params = {
            //         file_name:files[0]
            //     };
            //     commonService.uploading(params).then(res => {
            //         this.attachment.push({
            //             name:res.file_name,
            //             url:res.download_url
            //         });
            //     }).catch( err => {
            //         this.$message.error(err.message);
            //     })
            // },
            getFiles(val) {
                this.attachment = val;
            },
            onCancel(){
                this.close();
            },
            close(refresh) {
                this.$modal.close();
                refresh && refresh === true ? this.callback() : '';
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
